import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	feedbackTitle: {
		id: 'command-palette-integration.controllers.use-feedback-collector.feedback-title',
		defaultMessage: 'Share your thoughts',
		description: 'Title of the feedback collector dialog',
	},
	feedbackButtonText: {
		id: 'command-palette-integration.controllers.use-feedback-collector.feedback-button-text',
		defaultMessage: 'Let us know',
		description: 'Text of button to open feedback collector dialog',
	},
	feedbackContentText: {
		id: 'command-palette-integration.controllers.use-feedback-collector.feedback-content-text',
		defaultMessage: 'Got feedback?',
		description: 'Text of button to open feedback collector dialog in the command palette',
	},
});
